// extracted by mini-css-extract-plugin
export default {"hierarchyDepth":"table-row-chunk-module__hierarchyDepth--zXawp","missingSubIssuesText":"table-row-chunk-module__missingSubIssuesText--qp4eO"};